export default "__VITE_ASSET__2XUwTGR___";